import { render, staticRenderFns } from "./NameAndPricing.vue?vue&type=template&id=be89aa22"
import script from "./NameAndPricing.vue?vue&type=script&lang=ts"
export * from "./NameAndPricing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports